import { BaseUrlFormatter } from "../../../base";
export class PlayerMarketsUrlFormatter extends BaseUrlFormatter {
    composeEndpoint(request) {
        return `v2/player/${request.playerId}/markets`;
    }
}
//# sourceMappingURL=PlayerMarketsUrlFormatter.js.map